import { TRANSITION_SEQUENCE } from '../../enums/model.enums';
import { TransitionSection } from './transitionSection';
export class Transition {
    /**
     * Constructor of Transition Class
     * @param {number} duration Duration of the transition in minutes
     * @param {TRANSITION_SEQUENCE} positionInOrder Whether the Transition happens before, after
     * or 'instead of' the partial connection
     * @param {TransitionSection[]} sections The individual route sections of this transition
     */
    constructor(duration, positionInOrder, sections) {
        this._duration = duration;
        this._positionInOrder = positionInOrder;
        this._sections = sections;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Transition}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.duration = values.duration ? values.duration : 0;
        sanitizedValues.positionInOrder = values.positionInOrder ? values.positionInOrder : TRANSITION_SEQUENCE.AFTER;
        sanitizedValues.sections = [];
        if (values.sections) {
            for (const section of values.sections) {
                sanitizedValues.sections.push(TransitionSection.factory(section));
            }
        }
        return new Transition(sanitizedValues.duration, sanitizedValues.positionInOrder, sanitizedValues.sections);
    }
    /**
     * gets the internal _duration
     * @returns {number}
     */
    get duration() {
        return this._duration;
    }
    /**
     * sets the internal _duration
     * @param value
     */
    set duration(value) {
        this._duration = value;
    }
    /**
     * gets the internal _positionInOrder
     * @returns {TRANSITION_SEQUENCE}
     */
    get positionInOrder() {
        return this._positionInOrder;
    }
    /**
     * sets the internal _positionInOrder
     * @param value
     */
    set positionInOrder(value) {
        this._positionInOrder = value;
    }
    /**
     * gets the internal _sections
     * @returns {TransitionSection}
     */
    get sections() {
        return this._sections;
    }
    /**
     * sets the internal _sections
     * @param value
     */
    set sections(value) {
        this._sections = value;
    }
}
//# sourceMappingURL=transition.js.map